<!-- 订单详情 -->

<template>
    <div class="prder-details">
        <w-dialog ref="dialogRef" class="add-dialog" title="详情" width="55%" btnWidth="140px" top="5vh"
            :hideFooter="true">
            <!-- 停车场地信息头部 -->
            <div class="parking-header">
                <div class="parking-icon">
                   <img src="@/assets/img/parking-icon.png" alt="">
                </div>
                <div class="parking-info">
                    <div class="parking-title">停车场地：{{ orderDetails.station.s_name || '' }}</div>
                    <div v-if="orderDetails.s_park_fee" class="parking-price">{{ orderDetails.s_park_fee || '' }}</div>
                </div>
            </div>

            <el-row :gutter="30" class="content-row">
                <!-- 基本信息 -->
                <el-col :span="12">
                    <div class="info-section">
                        <div class="section-title">
                            <span class="title-indicator"></span>
                            基本信息
                        </div>
                        <div class="info-content">
                            <div class="info-item">
                                <span class="info-label">会员信息：</span>
                                <span class="info-value">{{ orderDetails.m_mobile || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">是否PLUS会员：</span>
                                <span class="info-value">{{ orderDetails.open_monthly_card || '' }}</span>
                            </div>
                        </div>
                    </div>
                </el-col>

                <!-- 订单信息 -->
                <el-col :span="12">
                    <div class="info-section">
                        <div class="section-title">
                            <span class="title-indicator green"></span>
                            订单信息
                            
                        </div>
                        <div class="info-content">
                            <div class="info-item justify-between">
                                <div class="flex">
                                    <span class="info-label">车牌号：</span>
                                    <span class="info-value">{{ orderDetails.ot_plate || '' }}</span>
                                </div>
                               
                                <span class="status-badge" :class="statusMap(orderDetails.or_status).color">{{statusMap(orderDetails.or_status).title}}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">入场时间：</span>
                                <span class="info-value">{{ orderDetails.ot_enter_time || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">停车时长：</span>
                                <span class="info-value">{{ orderDetails.ot_park_period_time || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">订单金额：</span>
                                <span class="info-value">{{ orderDetails.ot_total_money || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">优惠金额：</span>
                                <span class="info-value discount">{{ orderDetails.ot_discount_money || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">积分抵扣：</span>
                                <span class="info-value discount">{{ orderDetails.ot_integral_money || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">实际支付：</span>
                                <span class="info-value amount">{{ orderDetails.ot_pay_money || '' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">支付时间：</span>
                                <span class="info-value">{{ orderDetails.ot_send_coupon_endtime || '' }}</span>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </w-dialog>
    </div>
</template>

<script setup>
import { ref, } from "vue";
// import { ElMessage, } from "element-plus";
import chargingBlue from '@/assets/img/charging-blue.png';
import chargingGreen from '@/assets/img/charging-green.png';

const props = defineProps({
    orderDetails: {
        type: Object,
        default() {
            return {};
        },
    },
});

const statusMap = (status) => {
    return {
        title: status === 1 ? '待交' : status === 2 ? '缴费成功' : status === 3 ? '订单取消' : status === 4 ? '已退款' : '欠款待交',
        color: status === 1 ? 'bg-orange' : status === 2 ? 'bg-theme' : status === 3 ? 'bg-gray' : status === 4 ? 'bg-red' : 'bg-gray',
    }
}
const emits = defineEmits(["onClickUser"]);
const dialogRef = ref(null);  // 弹框对象
/**
 * 
 * 打开弹框
 * 
 * */
const openDialog = () => {
    dialogRef.value.show();
};
/**
 * 
 * 关闭弹框
 * 
 * */
const closeDialog = () => {
    dialogRef.value.close();
};
/**
 * 
 * 点击用户查看用户订单详情
 * 
 * */
const onClickUser = () => {
    emit("onClickUser", props.orderDetails);
}

defineExpose({
    openDialog,
    closeDialog,
    onClickUser,
});


</script>

<style lang="scss" scoped>

.prder-details {
    .status-badge{
        display: flex;
        align-items: center;
        padding: 12px 0;
        color: #fff;
        padding: 5px 12px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: normal;
        line-height: 1;
    }
    .bg-orange{
        background-color: #ff6b35;
        
    }
    .bg-theme{
        background-color: rgb(221, 238, 238);
        border: 1px solid #00c896;
        color: #00c896;
    }
    .bg-gray{   
        background-color: #f0f0f0;
        color: #333;
    }
    .bg-red{
        background-color:rgb(255, 221, 221);
        border: 1px solid #ff0000;
        color: #ff0000;
    }
    .add-dialog {
        .el-dialog__body {
            padding: 20px 30px 30px 30px;
            background-color: #f8f9fa;
        }
    }

    .parking-header {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        padding: 0 20px;

        .parking-icon {
            width: 60px;
            height: 60px;
            border-radius: 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-right: 15px;
            position: relative;

           

            .icon-text {
                color: white;
                font-size: 24px;
                font-weight: bold;
            }
        }

        .parking-info {
            .parking-title {
                font-size: 18px;
                font-weight: 600;
                color: #333;
                margin-bottom: 5px;
            }

            .parking-price {
                display: inline-block;
                background-color: #fff;
                border: 1px solid #ff6b35;
                color: #ff6b35;
                padding: 4px 12px;
                border-radius: 4px;
                font-size: 14px;
            }
        }
    }

    .content-row {
        margin: 0 !important;
    }

    .info-section {
        background: white;
        height: calc(100% - 20px);
        border-radius: 8px;
        overflow: hidden;
        

        .section-title {
            display: flex;
            align-items: center;
            padding: 15px 20px;
            font-weight: 600;
            font-size: 16px;
            color: #333;
            position: relative;

            .title-indicator {
                position: absolute;
                left: 0;
                top: 23px;
                width: 16px;
                height: 10px;
                background-color: #00c896;
                margin-right: 18px;

                &.green {
                    background-color: #00c896;
                }
            }

        }

        .info-content {
            padding: 20px;
            background-color: #f8f9fa;
            border-radius: 8px;
            height: 100%;
        }
        .justify-between{
            justify-content: space-between;
        }
        .info-item {
            display: flex;
            align-items: center;
            padding: 12px 0;

            &:last-child {
                border-bottom: none;
            }

            .info-label {
                color: #888;
                font-size: 14px;
                width: 105px;

            }

            .info-value {
                color: #333;
                font-size: 14px;
                font-weight: 500;

                &.discount {
                    color: #ff6b35;
                }

                &.amount {
                    color: #00c896;
                    font-weight: 600;
                    font-size: 16px;
                }
            }
        }
    }
}
</style>